import { render } from "./AdminSection.vue?vue&type=template&id=2b93416c"
import script from "./AdminSection.vue?vue&type=script&lang=js"
export * from "./AdminSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__